import axios from 'axios'

const micAjax = function createHttpClient () {
  let httpClient = null
  httpClient = axios.create()
  // 处理请求设置
  httpClient.interceptors.request.use(config => {
    // 让每个请求携带token-- ['key_login_token']为自定义key 请根据实际情况自行修改
    // config.headers['header-login-token'] = getToken();
    return config
  },
  err => {
    return Promise.reject(err)
  }
  )

  // 处理返回结果
  httpClient.interceptors.response.use(
    res => {
      if (res.status === 200) {
        // 正确处理方法
        // window.location.href = '#login';
        return Promise.resolve(res)
      } else {
        return Promise.reject(res)
      }
      // return res
    },
    err => {
      const error = err.response
      if (error.status === 401) {
        // 开发
        // window.location.href = '/'

        // 打包
        window.location.href = '#/'
      }
      if (error.status === 400) {
        // window.location.href = '/'
      }
      if (error.status === 402 || error.status === 403 || error.status === 404) {
        window.location.href = '#/login'
        // 打包
        // window.location.href = '#/login?loginStatus=' + error.status,
      }
      return Promise.reject(error)
    }
  )
  return httpClient
}

export default {
  created () {
    this.$axios = micAjax()
  }
}



// WEBPACK FOOTER //
// ./src/utils/responseIntercept.js